import { FieldContext } from "../contexts/FieldContext";
import { useFormState } from "@ngt/forms-core";
import { FC, useContext, useEffect } from "react";

const StepUpdater: FC<{setCompleted: React.Dispatch<React.SetStateAction<Record<number, boolean>>>}> = ({setCompleted}) => {
    const {errors} = useFormState({ errors: true});
    const fields = useContext(FieldContext);

    useEffect(() => {
        setCompleted(current => {
            for (let key in fields) {
                if (!current[+key]) {
                    current[+key] = false;
                }
            }

            const errorKeys = errors ? Object.keys(errors) : [];

            return Object.keys(current).reduce<Record<number, boolean>>((newRecord, key) => {
                const hasError = fields?.[+key]?.some(x => errorKeys.some(y => y === x || y.startsWith(`${x}.`))) ?? true;

                newRecord[+key] = !hasError;

                return newRecord;
            }, {});
        });
    }, [errors, setCompleted, fields]);

    //return <pre>{JSON.stringify(fields, null, '\t')}</pre>;

    return null;
};

export default StepUpdater;